import React from 'react';

interface PasswordValidation {
  minLength: boolean;
  hasUppercase: boolean;
  hasLowercase: boolean;
  hasNumber: boolean;
  hasSpecialChar: boolean;
  passwordsMatch: boolean;
  notSameAsCurrent: boolean;
}

interface PasswordValidationRulesProps {
  password: string;
  confirmPassword: string;
  currentPassword: string;
  className?: string;
}

const PasswordValidationRules: React.FC<PasswordValidationRulesProps> = ({
  password,
  confirmPassword,
  currentPassword,
  className = ''
}) => {
  const validatePassword = (password: string, confirmPassword: string, currentPassword: string): PasswordValidation => {
    return {
      minLength: password.length >= 8,
      hasUppercase: /[A-Z]/.test(password),
      hasLowercase: /[a-z]/.test(password),
      hasNumber: /[0-9]/.test(password),
      hasSpecialChar: /[^A-Za-z0-9]/.test(password),
      passwordsMatch: password === confirmPassword && confirmPassword !== '',
      notSameAsCurrent: password !== currentPassword && password !== ''
    };
  };

  const validation = validatePassword(password, confirmPassword, currentPassword);

  const ValidationRule: React.FC<{ isValid: boolean; text: string }> = ({ isValid, text }) => (
    <div className={`validation-rule ${isValid ? 'valid' : 'invalid'}`}>
      <span className="validation-icon">
        {isValid ? '✓' : '✗'}
      </span>
      <span className="validation-text">{text}</span>
    </div>
  );

  return (
    <div className={`password-validation-rules ${className}`}>
      <h4 className="validation-title">Password Requirements:</h4>
      <div className="validation-list">
        <ValidationRule 
          isValid={validation.minLength} 
          text="At least 8 characters long" 
        />
        <ValidationRule 
          isValid={validation.hasUppercase} 
          text="Contains uppercase letter (A-Z)" 
        />
        <ValidationRule 
          isValid={validation.hasLowercase} 
          text="Contains lowercase letter (a-z)" 
        />
        <ValidationRule 
          isValid={validation.hasNumber} 
          text="Contains number (0-9)" 
        />
        <ValidationRule 
          isValid={validation.hasSpecialChar} 
          text="Contains special character (!@#$%^&*)" 
        />
        <ValidationRule 
          isValid={validation.notSameAsCurrent} 
          text="Different from current password" 
        />
        <ValidationRule 
          isValid={validation.passwordsMatch} 
          text="Passwords match" 
        />
      </div>
    </div>
  );
};

export default PasswordValidationRules;